export default {
  0: {
    type: 'bt',
    success: 'success'
  },
  1: {
    type: 'rfid',
    success: 'success'
  },
  2: {
    type: 'qr',
    success: 'success'
  },
  3: {
    type: 'bt',
    success: 'fail-unregistered'
  },
  4: {
    type: 'rfid',
    success: 'fail-unregistered'
  },
  5: {
    type: 'qr',
    success: 'fail-unregistered'
  },
  6: {
    type: 'bt',
    success: 'fail-disabled'
  },
  7: {
    type: 'rfid',
    success: 'fail-disabled'
  },
  8: {
    type: 'qr',
    success: 'fail-disabled'
  },
  9: {
    type: 'bt',
    success: 'fail-out-of-interval'
  },
  10: {
    type: 'rfid',
    success: 'fail-out-of-interval'
  },
  11: {
    type: 'qr',
    success: 'fail-out-of-interval'
  }
}



// WEBPACK FOOTER //
// ./src/components/event/toggleTypes.js